import React, { useState } from "react";
import "../../pages/forms/form7.css";
import { useNavigate } from "react-router-dom";
import { Notify } from "notiflix";
import axios from "axios";
import { Loading } from 'notiflix/build/notiflix-loading-aio';


const PLANETS = [
  "செவ்",
  "புத",
  "சந்",
  "குரு",
  "சுக்",
  "லக்",
  "சனி",
  "கேது",
  "ராகு",
  "சூரி",
  "மா",
];

const EditForm7 = ({
  profile_id,
  formData,
  setFormData,
  RasiChart,
  setRasiChart,
  AmsamChart,
  setAmsamChart,
  setStep,
  formData2,
  formData3,
  formData4,
  formData5,
  FirstFormData
}) => {
  const [selectedBox, setSelectedBox] = useState(null);
  const [selectedPlanets, setSelectedPlanets] = useState([]);
  const [Loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const handleBoxClick = (boxKey) => {
    setSelectedBox(boxKey);

    const chart = boxKey.startsWith("r") ? RasiChart : AmsamChart;
    const planetsInBox = chart[boxKey]?.trim()
      ? chart[boxKey].trim().split(" ")
      : [];

    setSelectedPlanets(planetsInBox);
  };

  // const handleSubmit = () => {

  const handleSubmit = () => {
    // Loading.arrows();

    const formDataToSend = new FormData();

    // Text fields
    formDataToSend.append("name", FirstFormData.name);
    formDataToSend.append("profile_id", profile_id);
    formDataToSend.append("mobilenumber", FirstFormData.mobile);
    formDataToSend.append("password", formData2.password);
    formDataToSend.append("profile_category", formData2.profileCategory);
    formDataToSend.append("registered_by", FirstFormData.registeredBy);
    formDataToSend.append("gender", FirstFormData.gender);
    formDataToSend.append("dob_day", FirstFormData.dobDay);
    formDataToSend.append("dob_month", FirstFormData.dobMonth);
    formDataToSend.append("birth_year", FirstFormData.dobYear);
    formDataToSend.append("birth_hour", FirstFormData.birthHour);
    formDataToSend.append("birth_minute", FirstFormData.birthMinute);
    formDataToSend.append("birth_ampm", FirstFormData.birthAmPm);
    formDataToSend.append("birth_place", FirstFormData.birthPlace);

    formDataToSend.append("alt_mobile", FirstFormData.alternateMobile);
    formDataToSend.append("education", formData2.education);
    formDataToSend.append("jobdescription", formData2.jobDescription);
    formDataToSend.append("workplace", formData2.workPlace);
    formDataToSend.append("bloodgroup", formData2.bloodGroup);
    formDataToSend.append("bodytype", formData2.BodyType);
    formDataToSend.append("height", formData2.height);
    formDataToSend.append("weight", formData2.weight);
    formDataToSend.append("colour", formData2.colour);
    formDataToSend.append("monthlyincome", formData2.monthlyIncome);
    formDataToSend.append("caste", formData2.caste);
    formDataToSend.append("kulam", formData2.kulam);
    formDataToSend.append("kuladeivam", formData2.kuladeivam);
    formDataToSend.append("jathagam", formData2.jathagam);
    formDataToSend.append("star", formData2.star);
    formDataToSend.append("rasi", formData2.rasi);
    formDataToSend.append("laknam", formData2.laknam);
    formDataToSend.append("martialstatus", FirstFormData.maritalStatus);
    formDataToSend.append("living_place", formData4.livingPlace);
    formDataToSend.append("current_living_place", formData4.currentlivingplace);
    formDataToSend.append("fathername", formData3.fatherName);
    formDataToSend.append("mothername", formData3.motherName);
    formDataToSend.append("fatherjobdescription", formData3.fatherJob);
    formDataToSend.append("motherjobdescription", formData3.motherJob);
    formDataToSend.append("fathernative", formData3.fatherNative);
    formDataToSend.append("mothernative", formData3.motherNative);
    formDataToSend.append("siblings", formData3.siblings);
    formDataToSend.append("propertydetails", formData3.property);
    formDataToSend.append("address", formData3.address);
    formDataToSend.append("expectation", formData3.expectation);
    formDataToSend.append("dhisaiiruppu_planet", formData.planet);
    formDataToSend.append("dhisaiiruppu_Day", formData.Day);
    formDataToSend.append("dhisaiiruppu_Year", formData.Year);
    formDataToSend.append("dhisaiiruppu_Month", formData.Month);

    // File fields (images)
    if (formData5.profilePhoto1) {
      formDataToSend.append("profilephoto_1", formData5.profilePhoto1);
    }
    if (formData5.profilePhoto2) {
      formDataToSend.append("profilephoto_2", formData5.profilePhoto2);
    }
    if (formData5.horoscopePhoto) {
      formDataToSend.append("horoscope_photo", formData5.horoscopePhoto);
    }

    // Rasi Chart
    Object.keys(RasiChart).forEach(key => {
      formDataToSend.append(key, RasiChart[key]);
    });

    // Amsam Chart
    Object.keys(AmsamChart).forEach(key => {
      formDataToSend.append(key, AmsamChart[key]);
    });

    console.log('forndata', formData2)

    // console.log("form", JSON.stringify(formDataToSend, null, 2));

    // Send API request
    axios.post(
      "https://kovaikongunadumatrimony.com/kkm_admin/public/api/Update-user-data-Web",
      formDataToSend,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    ).then(response => {
      if (response.data.status === true) {
        Notify.success(response.data.message);
            navigate('/dashboard');
        Loading.remove();
      } else {
        Notify.failure(response.data.message);
        Loading.remove();
      }
    }).catch(error => {
      console.error("Form submission error:", error);
         Loading.remove();
      Notify.failure("Something went wrong while submitting the form.");
    });
  };


  const handleCheckboxChange = (planet) => {
    setSelectedPlanets((prev) =>
      prev.includes(planet)
        ? prev.filter((item) => item !== planet)
        : [...prev, planet]
    );
  };

  const handleSave = () => {
    if (selectedBox.startsWith("r")) {
      setRasiChart({ ...RasiChart, [selectedBox]: selectedPlanets.join(" ") });
    } else {
      setAmsamChart({
        ...AmsamChart,
        [selectedBox]: selectedPlanets.join(" "),
      });
    }
    setSelectedBox(null);
    setSelectedPlanets([]);
  };

  const renderModal = () => (
    <div className="planet-modal">
      <div className="modal-content">
        <h4>Edit Planets</h4>
        <div className="planet-options">
          {PLANETS.map((planet) => (
            <label key={planet}>
              <input
                type="checkbox"
                checked={selectedPlanets.includes(planet)}
                onChange={() => handleCheckboxChange(planet)}
              />
              {planet}
            </label>
          ))}
        </div>
        <div className="modal-actions">
          <button onClick={() => setSelectedBox(null)}>Close</button>
          <button onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );

  const renderTable = (chart, chartName) => (
    <table className="birth-table-2 m-auto">
      <tbody>
        <tr>
          <td onClick={() => handleBoxClick(`${chartName}12`)}>
            {chart[`${chartName}12`]}
          </td>
          <td onClick={() => handleBoxClick(`${chartName}1`)}>
            {chart[`${chartName}1`]}
          </td>
          <td onClick={() => handleBoxClick(`${chartName}2`)}>
            {chart[`${chartName}2`]}
          </td>
          <td onClick={() => handleBoxClick(`${chartName}3`)}>
            {chart[`${chartName}3`]}
          </td>
        </tr>
        <tr>
          <td onClick={() => handleBoxClick(`${chartName}11`)}>
            {chart[`${chartName}11`]}
          </td>
          <td
            className="form7chart-birth text-center"
            width="220"
            height="220"
            colSpan="2"
            rowSpan="2"
          >
            <p className="rasi-chart">
              {chartName === "r" ? "ராசி" : "நவாம்சம்"}
            </p>
          </td>
          <td onClick={() => handleBoxClick(`${chartName}4`)}>
            {chart[`${chartName}4`]}
          </td>
        </tr>
        <tr>
          <td onClick={() => handleBoxClick(`${chartName}10`)}>
            {chart[`${chartName}10`]}
          </td>
          <td onClick={() => handleBoxClick(`${chartName}5`)}>
            {chart[`${chartName}5`]}
          </td>
        </tr>
        <tr>
          <td onClick={() => handleBoxClick(`${chartName}9`)}>
            {chart[`${chartName}9`]}
          </td>
          <td onClick={() => handleBoxClick(`${chartName}8`)}>
            {chart[`${chartName}8`]}
          </td>
          <td onClick={() => handleBoxClick(`${chartName}7`)}>
            {chart[`${chartName}7`]}
          </td>
          <td onClick={() => handleBoxClick(`${chartName}6`)}>
            {chart[`${chartName}6`]}
          </td>
        </tr>
      </tbody>
    </table>
  );

  return (
    <div className="form7-wrapper">
      <div className="form7-container">
        <h2 className="form7-title">Rasi & Navamsam (7/7)</h2>

        <div className="row form7_row">
          <div className="col-md-6 col-lg-5 m-auto">
            <h5 className="chart-heading">ராசி கட்டம் (Rasi):</h5>
            {renderTable(RasiChart, "r")}
          </div>

          <div className="col-md-6 col-lg-5 m-auto">
            <h5 className="chart-heading">நவாம்சம் கட்டம் (Navamsam):</h5>
            {renderTable(AmsamChart, "a")}
          </div>
        </div>

        <div className="form7-btn-group">
          <button className="back-btn-7" onClick={() => setStep(6)}>
            Back
          </button>
          <button className="submit-btn-7" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
      {selectedBox && renderModal()}
    </div>
  );
};

export default EditForm7;
